/**
 * Which backend a session is currently routed to. Carried on the server-side
 * Token row (see backend/src/models/Token.ts) — never trusted from a client-
 * supplied header, query parameter, or local app setting. The client only
 * ever calls one public API URL; this value determines how the origin
 * routes the request (locally vs. proxied to the test origin), not which
 * URL the client calls.
 */
export var SessionEnvironment;
(function (SessionEnvironment) {
    SessionEnvironment["Production"] = "production";
    SessionEnvironment["Test"] = "test";
})(SessionEnvironment || (SessionEnvironment = {}));
//# sourceMappingURL=SessionEnvironment.js.map